import { render, staticRenderFns } from "./TrunkImportModal.vue?vue&type=template&id=4b52c1dc&scoped=true&"
import script from "./TrunkImportModal.vue?vue&type=script&lang=js&"
export * from "./TrunkImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52c1dc",
  null
  
)

export default component.exports